<template>
    <CModal
        :title="titleComponent"
        :show="showComponent"
        :color="colorComponent"
        :size="sizeComponent"
    >
        <CForm ref="formAddUserGroup" @submit="formSubmit($event, 'addUserGroup')">
            <CInput
                :isValid="checkIfFormValid({
                    formName:'addUserGroup',
                    fieldName:'email'
                })"
                :value.sync="$v.forms.addUserGroup.email.$model"
                :label="$t('email')"
                :disables="true"
            />
            <SelectAsync
                :isValid="checkIfFormValid({
                    formName:'addUserGroup',
                    fieldName:'group'
                })"
                :value.sync="$v.forms.addUserGroup.group.$model"
                :label="$t('group')"

                endpoint="/account.api/groups"
            />

            <ButtonLoading
                type="submit"
                :block="true"
                color="primary"
                :loading="forms.addUserGroup._loading"
            >
                <span>{{ $t('add_user_group') }}</span>
            </ButtonLoading>

        </CForm>
        <template #footer>
            <CButton color="secondary" @click="closeModal()">
                {{ $t("cancel") }}
            </CButton>
            <ButtonLoading color="success" @click="executeSubmitForm" :loading="forms.addUserGroup._loading">
                {{ $t("add_user_group") }}
            </ButtonLoading>
        </template>
    </CModal>
</template>

<script>
import formMixin from '~/mixins/form';
import { validationMixin } from "vuelidate";
import { required, sameAs } from "vuelidate/lib/validators"
import SelectAsync from '~/components/elements/SelectAsync.vue';
import ButtonLoading from '~/components/ButtonLoading.vue';
export default {
    name: "AddUserGroupModal",
    mixins: [formMixin, validationMixin],
    components: {
        SelectAsync,
        ButtonLoading
    },
    props:{
        title: String,
        show: Boolean,
        color: String,
        size: String,
        email: String|null,
    },

    data(){
        return {
            titleComponent: null,
            showComponent:false,
            colorComponent: "primary",
            sizeComponent: "lg",

            forms:{
                addUserGroup:{
                    email: null,
                    group: null,
                    _loading: false,
                },
            }
        }
    },

    validations:{
        forms:{
            addUserGroup:{
                email:{
                    required
                },
                group:{
                    required
                }
            }
        }
    },

    watch:{
        title(){
            this.titleComponent = this.title;
        },
        show(){
            this.showComponent = this.show;
            if(!this.show){
                this.resetForm('addUserGroup');
                this.$v.$reset();
            }
        },
        color(){
            this.colorComponent = this.color;
        },
        size(){
            this.sizeComponent = this.size;
        },

        email(){
            this.forms.addUserGroup.email = this.email;
        },

        showComponent(){
            this.$emit('update:show',this.showComponent);
        },
    },

    methods:{
        closeModal(){
            this.showComponent = false;
        },


        async formSubmit(e, formName){
            e.preventDefault();
            let response = await this.sendForm({ 
                formName , 
                url: '/account.api/users/add/user/group'
            });
            this.showComponent = false;

            this.$emit('submit',response);
        },

        executeSubmitForm(){
            this.$refs.formAddUserGroup.requestSubmit();
        }
    },

    mounted(){
        this.titleComponent = this.title;
        this.showComponent = this.show;
        this.colorComponent = this.color;
        this.sizeComponent = this.size;

        this.forms.addUserGroup.email = this.email;
    },
};
</script>

<style>
</style>